export default class VariableMetadata {
  name: string;

  type: string;

  sample: string | null;

  constructor(obj: any) {
    this.name = obj.name || '';
    this.type = obj.type || '';
    this.sample = obj.sample || null;
  }

  public static of(obj: any): VariableMetadata {
    return new VariableMetadata(obj || {});
  }

  public static ofList(obj: any[]): VariableMetadata[] {
    return (obj || []).map(this.of);
  }
}
